import React, { useEffect } from 'react';

import { SideNav } from '@common/SideNav';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, showTelnyxFeatures, State, tabActions } from '@store/index';
import { Link } from '@common/SideNav/types';

export const ServiceNavigation: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const location = useLocation();
  const { service_id } = useParams();

  const last_menu = useSelector((state: State) => state.tabs.last_menu);
  const isTelnyxUser = useSelector((state: State) => showTelnyxFeatures(state));

  const setLastMenu = (location: string | null) => {
    dispatch(tabActions.setLastMenu(location));
  };

  useEffect(() => {
    if (last_menu === null) setLastMenu(location.pathname);
  }, []);

  const router = [
    {
      name: 'Workspace',
      links: [
        // Not adding the permissions check for endpoint as it can be accessed by all users
        { name: 'Workflows', href: `/${service_id}/workflow` },
        { name: 'Modules', href: `/${service_id}/modules` },
        { name: 'Metadata', href: null, dividor: true },
        { name: 'Buckets', href: `/${service_id}/buckets` },
        { name: 'Variables', href: `/${service_id}/global-variables` },
        { name: 'Security', href: null, dividor: true },
        { name: 'Permissions', href: `/${service_id}/permissions` },
        { name: 'Reporting', href: null, dividor: true },
        { name: 'Executions', href: `/${service_id}/executions` },
      ],
    },
    {
      name: 'Account',
      links: [
        // { name: 'Resources', href: null, dividor: true },
        { name: 'Secrets', href: `/${service_id}/secrets` },
        isTelnyxUser && { name: 'Assistants', href: `/${service_id}/assistants` },
      ].filter(Boolean) as Link[],
    },
  ];

  return <SideNav router={router} active={last_menu} setActive={setLastMenu} />;
};
